
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prefit-chennai/pre-hyderabad",
      function () {
        return require("private-next-pages/prefit-chennai/pre-hyderabad.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prefit-chennai/pre-hyderabad"])
      });
    }
  